import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Link, makeStyles, Typography } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import ContactForm from './ContactForm';

const useStyles = makeStyles(() => ({
	pageTitle: {
		marginTop: '25px',
	},
	link: {
		display: 'flex',
		alignItems: 'center',
		padding: 0,
		marginBottom: '25px',
	},
	mailLink: {
		textTransform: 'none',
		textDecoration: 'underline',
		padding: 0,
	},
}));

const archiveUrl = 'www.archiv.brno.cz';
const primaryPhone = '+420 542 173 612';
const secondaryPhone = '+420 542 173 613';
const email = 'amb@brno.cz';

const Contact: FC = () => {
	const classes = useStyles();

	const { t } = useTranslation('contact');

	return (
		<>
			<Grid item xs={1} sm={2} md={1} />
			<Grid item xs={10} sm={8} md={4}>
				<Typography className={classes.pageTitle} variant="h5" color="primary">
					{t('page_title')}
				</Typography>
				<ContactForm />
			</Grid>
			<Grid item xs={1} sm={2} md={1} />

			<Grid item xs={1} sm={2} md={1} />
			<Grid item xs={10} sm={8} md={4}>
				<Typography variant="h5" color="primary" paragraph>
					{t('address_label')}
				</Typography>

				<Typography variant="body1" color="secondary" paragraph>
					{t('address_part_1')} <br />
					{t('address_part_2')}
				</Typography>

				<Link
					className={classes.link}
					href={`http://${archiveUrl}`}
					target="_blank"
					rel="noreferrer"
				>
					{archiveUrl}
					<OpenInNewIcon fontSize="small" style={{ marginLeft: '4px' }} />
				</Link>

				<Typography variant="h6" color="primary">
					{t('mobile_label')}:
				</Typography>
				<Typography variant="body1" color="secondary" paragraph>
					{primaryPhone} <br /> {secondaryPhone}
				</Typography>

				<Typography variant="h6" color="primary">
					{t('email_label')}:
				</Typography>

				<Typography variant="body1" color="primary" paragraph>
					<Link
						className={classes.mailLink}
						href={`mailto:${email}`}
						color="secondary"
					>
						{email}
					</Link>
				</Typography>
			</Grid>
			<Grid item xs={1} sm={2} md={1} />
		</>
	);
};

export default Contact;
